import auth0Client from "@/auth0";
import { Button } from "@spz/ui/components/button";
import { Typography } from "@spz/ui/components/typography";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import SpzLogo from "../assets/logo-spz.svg";

const AccountDeactivated: React.FC = () => {
  const { t } = useTranslation();

  const handleLoginAgain = useCallback(() => {
    auth0Client.loginWithRedirect();
  }, []);

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div className="gap-2" data-testid="logout-success-message">
            <Typography variant="h3">{t("logout_success_title")}</Typography>

            <Typography className="text-gray-700 text-subtitle">
              {t("logout_success_description")}
            </Typography>
          </div>
          <div className="gap-4 flex flex-col mb-6">
            <Button
              type="button"
              variant="secondary"
              onClick={handleLoginAgain}
              data-testid="logout-login-link"
            >
              {t("login_again")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDeactivated;
